import { actionCreatorFactory } from 'typescript-fsa';

export namespace UnmappedSymbolsToggleAction {
  const actionCreator = actionCreatorFactory('UnmappedSymbolsToggle');

  export const toggle = actionCreator('TOGGLE');
}
